module.exports = __webpack_public_path__ + "static/media/logo_tagline_inverted.3a71fffd.svg";